<template>
  <model-form
    ref="form"
    :model="userEmployeeJobType"
    :title="`Customize ${userEmployeeJobType.employeeJobType?.name || 'Job Type'} for ${userName}`"
    submodel
    modal-type="modal"
    :handled-actions="['edit']"
    @on-close="() => handleClose()"
  >
    <q-card-section>
      <div class="row q-gutter-md">
        <model-form-input
          field="overrideHourlyRate"
          :placeholder="userEmployeeJobType.hourlyRate"
          class="col"
          label="Override Hourly Rate"
          type="number"
          step="0.01"
          min="0"
          :prefix="currentCircuit.localeCurrencySymbol"
          clearable
          :rules="[
            val => val === null || val >= 0 || 'Can\'t be negative'
          ]"
        />
      </div>
      <div class="row q-gutter-md">
        <model-form-checkbox
          field="default"
          class="col"
          label="Default"
          bottom-slots
        />
      </div>
    </q-card-section>
  </model-form>
</template>

<script>
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'UserEmployeeJobTypeForm',
  components: {
    ModelForm
  },
  configuration: ['currentCircuit'],
  emits: ['on-close'],
  computed: {
    userName () {
      return this.userEmployeeJobType?.user?.name || 'User'
    }
  },
  models: {
    userEmployeeJobType: {
      employeeJobType: {
        fields: ['id', 'name', 'hourlyRate']
      },
      user: {
        fields: ['id', 'firstName', 'lastName']
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('on-close', this.userEmployeeJobType)
    }
  }
}

</script>
